import Typed from "typed.js";
import "waypoints/lib/jquery.waypoints.min.js";

$(function () {
  if ($(".title-white span").length) {
    var booknow = document.querySelector(".title-white span");
    new Typed(booknow, {
      strings: ["BOOK NOW"],
      typeSpeed: 100, // アニメーションのスピード
      backDelay: 4000,
      loop: true,
    });
  }
});
